module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/rumble-c31dbaf3aa83d347db151ee3d8e9b333.png";